import styled from 'styled-components';

import {grey, white} from '@drivesally/sally-ui/lib/libs/colors';

const TeamRow = styled.button`
  background: ${({selected}) => (selected ? grey : white)};
  border: none;
  cursor: pointer;
  display: block;
  font-size: 14px;
  padding: 12px 20px;
  text-align: left;
  width: 100%;

  &:hover {
    background: ${grey};
  }
`;

export default TeamRow;
